import { Icon } from "@chakra-ui/react";
const LogoutIcon = () => {
  return (
    <>
      <Icon
        width="4"
        height="5"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.8212 2.29647L10.4565 3.66118C12.0847 4.64941 13.1765 6.42824 13.1765 8.47059C13.1765 9.96828 12.5815 11.4046 11.5225 12.4637C10.4635 13.5227 9.0271 14.1176 7.52941 14.1176C6.03172 14.1176 4.59537 13.5227 3.53634 12.4637C2.47731 11.4046 1.88235 9.96828 1.88235 8.47059C1.88235 6.42824 2.97412 4.64941 4.59294 3.65176L3.23765 2.29647C1.28 3.65176 0 5.91059 0 8.47059C0 10.4675 0.793275 12.3826 2.20531 13.7947C3.61735 15.2067 5.53249 16 7.52941 16C9.52634 16 11.4415 15.2067 12.8535 13.7947C14.2655 12.3826 15.0588 10.4675 15.0588 8.47059C15.0588 5.91059 13.7788 3.65176 11.8212 2.29647ZM8.47059 0H6.58824V9.41176H8.47059"
          fill="#90A4AE"
        />
      </Icon>
    </>
  );
};

export default LogoutIcon;
